import { BaseProvider } from 'src/app/core/services/base-provider';
import * as i0 from "@angular/core";
import * as i1 from "./globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "./ls-helper.service";
export class RequirementReviewService extends BaseProvider {
    constructor(globals, http, ls) {
        super();
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.requirementReviewFormIsVisible = false;
        this.baseUrl = "userProcessRequirement";
    }
    markForRevision(userProcessId, processId, flag, data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl +
                this.baseUrl + `/process/${this.requirementId}/type/${this.requirementType}/verificationFlag/${flag}/userProcessId/${userProcessId}`;
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    unMarkForRevision(processId, hasForm) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl +
                this.baseUrl + `/cancel/process/${processId}` +
                `/requirementId/${this.requirementId}` +
                `/hasForm/${hasForm}`;
            this.http
                .post(this.url, null)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    getComments() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'lookup/requirement/comment/templates';
            this.http.get(this.url)
                .subscribe((data) => { resolve(data); }, (err) => { reject(err); });
        });
    }
}
RequirementReviewService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RequirementReviewService_Factory() { return new RequirementReviewService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LsHelperService)); }, token: RequirementReviewService, providedIn: "root" });
